import { getRequestBlob, postRequestBlob } from "./RequestConfig";

export const excelReport = async (reportType) => {
  try {
    const response = await postRequestBlob(
      `api/export/excel`,{reportType}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const excelReportDebiHist = async (reportType, date) => {
  try {
    const response = await getRequestBlob(
      `api/export/excel?reportType=${reportType}&effectiveDate=${date}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const excelReportDebiRaw = async (reportType, status, fromdate,toDate, dcrows) => {
  try {
    let payload = {
      reportType: reportType,
      status: status,
      effectiveDateStart: fromdate,
      effectiveDateEnd:toDate,
      dcList: dcrows,
    };
    const response = await postRequestBlob(`api/export/excel`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
